<!--
 * @Author: your name
 * @Date: 2020-08-24 14:48:46
 * @LastEditTime: 2020-10-14 15:06:35
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \jiachi\src\views\Home.vue
-->
<template>
  <div class="home">
    <swiper :options="option" v-if="banner.length">
      <swiper-slide v-for="(item, index) in banner" :key="index">
        <div
          class="swiper-wrap"
          :style="{ backgroundImage: 'url(' + item.image + ')' }"
        >
          <h1 v-if="index == 0"></h1>
          <p v-if="index == 0"></p>
        </div>
      </swiper-slide>
      <div class="dot" slot="pagination"></div>
    </swiper>
    <div class="neck">
      <div class="left">
        <h2>
          ABOUT <br />
          JIACHI
        </h2>
        <p class="sub-title">{{ about.name }}</p>
        <div class="hr">
          <hr />
        </div>
        <div class="desc" v-html>{{ spliceText(about.js, 50) }}</div>
        <router-link :to="{ path: '/about' }" tag="div" class="show-more-btn">
          <img src="../assets/img/show_more.png" class="show-more" />
          查看更多
        </router-link>
      </div>
      <!--  <video :src="about.images" controls class="neck-swipe"></video>-->
      <swiper :options="neck_swiper" class="neck-swipe">
        <swiper-slide v-for="(item, index) in 1" :key="index">
          <img
            src="../assets/img/del/625A0487.jpg"
            class="neck-swipe-img"
            style="object-fit: cover"
          />
        </swiper-slide>
        <!--<div class="neck_dot" slot="pagination"></div>-->
      </swiper>
    </div>
    <div
      class="action"
      id="action"
      :style="{ backgroundImage: 'url(' + actionBg + ')' }"
    >
      <div v-for="(item, index) in actions" :key="index">
        <p>{{ item.name }}</p>
        <span>
          <countTo
            v-if="show"
            class="moneySize"
            :start-val="0"
            :endVal="item.value"
            :duration="4000"
          ></countTo>
          <span class="moneySize" v-else>0</span>
          <span>{{ item.ext }}</span>
        </span>
        <hr />
      </div>
    </div>
<!--    <div class="box">-->
<!--      <div class="service">-->
<!--        <div class="head">-->
<!--          <h2>-->
<!--            SERVICE-->
<!--            <br />CAPABILITES-->
<!--          </h2>-->
<!--          <p class="sub-title">服务能力</p>-->
<!--          <router-link :to="{ path: '/case' }" tag="div" class="show-more-btn">-->
<!--            <img src="../assets/img/show_more.png" class="show-more" />-->
<!--            查看更多-->
<!--          </router-link>-->
<!--        </div>-->
<!--        <div class="hr">-->
<!--          <hr />-->
<!--        </div>-->
<!--        <div class="service-wrap">-->
<!--          <div-->
<!--            v-for="(item, index) in services"-->
<!--            :key="index"-->
<!--            :style="{ backgroundImage: 'url(' + item.image + ')' }"-->
<!--            @click="$router.push({ path: '/case', query: { idx: index } })"-->
<!--          >-->
<!--            <div class="item">-->
<!--              <p>-->
<!--                {{ item.title }}-->
<!--                <br />-->
<!--                <span>{{ item.ex_title }}</span>-->
<!--              </p>-->
<!--              <span>{{ spliceText(item.js, 50) }}</span>-->
<!--            </div>-->
<!--            <div class="mask"></div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
    <div class="product-center box">
      <div class="wrap">
        <div class="head">
          <h2>
            Civilian
            <br />Products
          </h2>
          <p class="sub-title">民用产品</p>
          <router-link
            :to="{ path: '/product' }"
            tag="div"
            class="show-more-btn"
          >
            <img src="../assets/img/show_more.png" class="show-more" />
            查看更多
          </router-link>
        </div>
        <div class="product-box">
          <router-link
            tag="div"
            :to="'/product?id=' + products.id"
            class="products"
            v-for="(products, index) in product"
            :key="index"
            :style="{
              width: index == 2 ? '595px' : '292px',
              marginRight: index == 2 || index == 6 ? '0' : '10px',
            }"
          >
            <div class="img-box">
              <img :src="products.image" alt srcset />
            </div>
            <p class="name">
              {{ products.name }}
              <span>系列</span>
            </p>
            <p class="guige" v-show="products.ex_title">
              <span
                v-for="(ex_title, index) in products.ex_title"
                :key="index"
                >{{ ex_title }}</span
              >
            </p>
          </router-link>
        </div>
      </div>
    </div>
    <div class="news box">
      <div class="head">
        <h2>NEWS</h2>
        <p class="sub-title">最新资讯</p>
        <router-link
          :to="{ path: '/news/company' }"
          tag="div"
          class="show-more-btn"
        >
          <img src="../assets/img/show_more.png" class="show-more" />
          查看更多
        </router-link>
      </div>
      <div class="news-box">
        <div
          class="left"
          @click="
            $router.push({
              path: '/news/company/detail',
              query: { id: news.first.id },
            })
          "
        >
          <img :src="news.first.image" alt srcset />
          <div class="down">
            <p class="bold">{{ news.first.name }}</p>
            <p class="desc">{{ spliceText(news.first.summary, 115) }}</p>
          </div>
        </div>
        <div class="right">
          <div
            v-for="(item, index) in news.list"
            :key="index"
            @click="
              $router.push({
                path: '/news/company/detail',
                query: { id: item.id },
              })
            "
          >
            <img :src="item.image" alt srcset />
            <div>
              <p class="bold">{{ item.date }}</p>
              <span>{{ spliceText(item.summary, 40) }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import {
  getBanner,
  getAction,
  getPt,
  gsjj,
  fw,
  classe,
  article,
} from '../assets/js/api'
export default {
  name: 'Home',
  components: {},
  data() {
    var _this = this
    return {
      active: 0,
      show: false,
      banner: [],
      actions: [],
      actionBg: '',
      about: {},
      services: [],
      neck_swiper: {
        loop: true,

        pagination: {
          el: '.neck_dot',
        },
      },
      product: [],
      news: {
        first: {},
      },
      option: {
        autoplay: {
          delay: 2000,
        },
        pagination: {
          el: '.dot',
        },
        on: {
          slideChangeTransitionStart: function () {
            _this.active = this.realIndex
          },
        },
      },
      product_swiper: {
        pagination: {
          el: '.product_dot',
        },
      },
    }
  },
  created() {
    getBanner().then((r) => {
      this.banner = r.data.data
    })
    getAction().then((r) => {
      r.data.data.forEach((val) => {
        val.value = Number(val.value)
      })
      this.actions = r.data.data
    })
    getPt().then((r) => {
      this.actionBg = r.data.data[0].image
    })
    gsjj().then((r) => {
      r.data.images = r.data.images.split(',') || []
      this.about = r.data
    })
    fw().then((r) => {
      this.services = r.data.data
    })
    classe({
      limit: 7,
    }).then((r) => {
      // r.data.data.push({})

      r.data.data.forEach((val) => {
        if (val.ex_title) {
          val.ex_title = val.ex_title.split('/')
        }
      })

      this.product = r.data.data
    })
    article({
      limit: 5,
      page: 1,
      where: {
        type: 1,
      },
    }).then((r) => {
      this.news.first = r.data.data[0] || {}
      this.news.list = r.data.data.slice(1, 5)
    })
  },
  mounted() {
    let action_top = document.getElementById('action').offsetTop
    window.addEventListener('scroll', () => {
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop
      if (scrollTop >= action_top - 500) {
        this.show = true
      }
    })
  },
}
</script>

<style lang="less" scoped>
.swiper-wrap {
  background-image: url('../assets/img/del/swiper.png');
  background-size: cover;
  background-repeat: no-repeat;
  height: 920px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  color: #fff;

  h1 {
    margin: 56px;
    text-align: center;
    font-size: 60px;
    font-family: Source Han Sans CN;
    font-weight: 400;
  }

  p {
    padding: 20px 44px;
    border: 1px solid #fff;
    word-spacing: 20px;

    font-size: 25px;
    font-family: Source Han Sans CN;
    font-weight: 500;
  }
}

.dot {
  text-align: center;
  position: absolute;
  bottom: 50px !important;
  left: 0;
  z-index: 1;

  /deep/ span {
    width: 74px;
    height: 12px;
    background: rgba(255, 255, 255, 0.5);
    border-radius: 6px;
    transition: all 0.15s linear;
  }

  /deep/.swiper-pagination-bullet-active {
    background: rgba(255, 255, 255, 1);
  }
}

.neck {
  box-sizing: border-box;
  font-size: 0;
  display: flex;
  margin-bottom: 45px;

  & > div {
  }

  .neck-swipe {
    width: calc(100% - 730px);
    height: 680px;
    object-fit: cover;

    // .neck_dot {
    //   text-align: center;
    //   position: absolute !important;
    //   bottom: 20px !important;
    //   z-index: 1;

    //   /deep/.swiper-pagination-bullet {
    //     border-radius: 0;
    //     background: #cccccc;
    //     opacity: 1;
    //   }

    //   /deep/.swiper-pagination-bullet.swiper-pagination-bullet-active {
    //     background: #367cc4;
    //   }
    // }
  }

  .left {
    background-image: url('../assets/img/neck-bg.png');
    background-size: 575px 636px;
    background-repeat: no-repeat;
    background-position: 208px 16px;
    color: black;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    justify-content: center;
    // align-items: center;
    padding-right: 120px;
    width: 730px;
    padding-left: 357px;

    & > * {
      width: 100%;
    }

    h2 {
      font-size: 30px;
      font-family: Source Han Sans CN;
      font-weight: bold;
      color: rgba(0, 0, 0, 1);
      line-height: 45px;
      width: 176px;
      word-break: break-all;
    }

    .desc {
      font-size: 16px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: rgba(0, 0, 0, 1);
      margin-bottom: 50px;
      line-height: 28px;
    }
  }
}

.sub-title {
  font-size: 26px;
  font-family: Source Han Sans CN;
  font-weight: bold;
  color: rgba(0, 0, 0, 0.7);
}

.hr {
  hr {
    width: 26px;
    height: 5px;
    margin: 50px 0;
    background: #9a9a9a;
    border: none;
    box-shadow: none;
    outline: none;
  }
}

.action {
  height: 411px;
  width: 100%;
  background: url('../assets/img/action-bg.png') no-repeat;
  background-size: cover;
  display: flex;
  align-items: center;
  justify-content: center;

  & > div:last-child {
    margin-right: 0;
  }

  & > div {
    width: 270px;
    height: 269px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: #0858a6;
    margin-right: 40px;
    cursor: pointer;
    background: white;

    p {
      font-size: 20px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      margin-bottom: 65px;
    }

    & > span {
      font-family: Source Han Sans CN;

      margin-bottom: 32px;

      .moneySize {
        font-size: 38px;
        font-weight: bold;
      }

      span {
        font-size: 24px;
        font-weight: 400;
      }
    }

    hr {
      width: 74px;
      height: 1px;
      background-color: #0858a6;
    }
  }

  & > div:hover {
    background: url('../assets/img/home-neck-bg.png') no-repeat;
    background-size: cover;
    color: white;

    hr {
      background-color: white;
    }
  }
}

.box {
  width: 100%;
  box-sizing: border-box;

  .head {
    position: relative;

    h2 {
      font-size: 30px;
      font-family: Source Han Sans CN;
      font-weight: bold;
      color: rgba(0, 0, 0, 1);
      line-height: 45px;
    }

    .show-more-btn {
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-50%);
    }

    & > img {
      height: 60px;
    }
  }

  & > div {
    width: 1200px;
    margin: 0 auto;
  }
}

.service {
  padding-top: 100px;
  padding-bottom: 125px;

  .service-wrap {
    display: flex;

    & > div:last-child {
      margin: 0;
    }

    & > div {
      width: 220px;
      height: 260px;
      margin-right: 25px;
      background-image: url('https://lanhu.oss-cn-beijing.aliyuncs.com/ps6238f4d5b7097f40-b6a9-41cf-9926-04825937efa7');
      background-size: cover;
      background-repeat: no-repeat;
      cursor: pointer;
      transition: all 0.15s linear;
      position: relative;
      overflow: hidden;

      & > .mask {
        width: 100%;
        height: 114px;
        position: absolute;
        bottom: 0;
        left: 0;
        background: linear-gradient(to bottom, transparent 20%, black);
      }

      & > div.item {
        width: 100%;
        height: 100%;
        padding: 0 16px;
        padding-top: 27px;
        padding-bottom: 19px;
        box-sizing: border-box;
        color: white;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        transition: all 0.15s linear;
        position: absolute;
        top: 146px;
        z-index: 1;

        span {
          font-size: 14px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: rgba(250, 248, 248, 1);
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
        }

        p {
          font-size: 24px;
          font-family: Source Han Sans CN;
          font-weight: bold;
          color: rgba(255, 255, 255, 1);
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
        }
      }
    }

    div:hover {
      transform: scale(1.1);

      & > div.item {
        top: 0;
      }
    }
  }
}

.product-center {
  padding-top: 45px;
  background: url('../assets/img/product-center-bg.png') no-repeat;
  background-size: cover;
  padding-bottom: 20px;

  .product-box {
    display: flex;
    flex-wrap: wrap;
    margin-top: 36px;

    .products {
      margin-bottom: 40px;
      padding: 10px;
      padding-bottom: 20px;
      box-sizing: border-box;
      width: 292px;
      cursor: pointer;
      background: white;
      transition: all 0.15s linear;

      .img-box {
        width: 100%;
        height: 200px;
        background: rgba(234, 238, 244, 1);
        display: flex;
        justify-content: center;
        align-items: center;

        img {
          width: 170px;
          height: 132px;
          object-fit: cover;
        }
      }

      .name {
        text-align: center;
        margin: 20px 0;
        font-size: 20px;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: rgba(19, 112, 204, 1);

        span {
          font-weight: 400;
        }
      }

      .guige {
        text-align: center;

        span:nth-child(2) {
          margin-left: 30px;
          background: #f7b80e;
        }

        span {
          padding: 0 23px;
          height: 30px;
          background: #0858a6;
          border-radius: 15px;
          color: white;
        }
      }
    }

    .products:hover {
      box-shadow: 0px 0px 31px 0px rgba(0, 0, 0, 0.21);
    }
  }

  .product_dot {
    text-align: center;

    /deep/.swiper-pagination-bullet {
      border-radius: 0;
    }
  }
}

.news {
  background: url('../assets/img/home-news-bg.png') no-repeat;
  background-size: 1320px 795px;
  padding: 110px 0;
  background-position: 117px 111px;
  padding-bottom: 190px;

  & > div.news-box {
    display: flex;
    justify-content: space-between;
    margin-top: 50px;
  }

  .bold {
    font-size: 24px;
    font-family: Source Han Sans CN;
    font-weight: bold;
    color: rgba(0, 0, 0, 1);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .left {
    width: 680px;
    height: 540px;
    cursor: pointer;

    img {
      width: 100%;
      height: 365px;
      vertical-align: middle;
    }

    .down {
      width: 100%;
      padding: 29px 41px;
      box-sizing: border-box;
      background: white;
      height: 175px;

      .desc {
        margin-top: 20px;
        font-size: 16px;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: rgba(154, 154, 154, 1);

        word-break: break-all;
      }
    }
  }

  .right {
    & > div {
      cursor: pointer;
      width: 480px;
      height: 120px;
      background: rgba(222, 222, 222, 1);
      display: flex;
      justify-content: space-between;
      padding: 20px;
      box-sizing: border-box;
      margin-bottom: 20px;

      & > div {
        width: calc(100% - 180px);
      }

      img {
        width: 160px;
        height: 80px;
      }

      .bold {
        margin-bottom: 10px;
      }

      span {
        font-size: 16px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: rgba(0, 0, 0, 1);
      }
    }
  }
}
</style>
